import { forwardRef } from 'react'
import { type IScrollbarsPropsRef } from 'shared/ui/Scrollbar/hooks/useScrollbarApiRef'
import { PlainScrollbar } from './PlainScrollbar'
import { VirtualizedScrollbar } from './VirtualizedScrollbar'
import { type IScrollbarProps } from './types'

const ScrollbarRef = forwardRef<IScrollbarsPropsRef, IScrollbarProps>((props, ref) => {
  if (props.virtualized) {
    return <VirtualizedScrollbar {...props} ref={ref} />
  }

  return <PlainScrollbar {...props} ref={ref} />
})

ScrollbarRef.displayName = 'Scrollbar'

export const Scrollbar = ScrollbarRef
